import { Amplify } from 'aws-amplify';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: {
            required: true,
          },
        },
      },
    },
  });
};

export const getApiConfig = () => ({
  apiUrl: import.meta.env.VITE_API_URL || '',
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
});
